const initCharacterTabs = function () {
	const $characterContent = $('.ren-character');
	const $seriesContent = $('#series-content');

	if ($characterContent.length || $seriesContent.length) {
		$seriesContent.add($characterContent).on('click', 'li.character-tab', function (e) {
			e.preventDefault();
			const tabItem = $(
				'#' +
				$(this)
					.attr('id')
					.replace(/\s*tab\s*/, 'item')
			);
			$('.character-tab, .character-item').removeClass('active');
			tabItem.addClass('active');
			$(this).addClass('active');
			$(this).on('focus');
		});
	}
};

export default initCharacterTabs;
